import React from "react";
import OrderSummary from "../components/checkout/OrderSummary";
import { PaymentSection } from "../components/checkout/PaymentSection";

const CheckoutPage = () => {
  return (
    <>
      <div className="grid lg:grid-cols-[minmax(min-content,calc(50%+calc(66rem/2-52rem/2)))_1fr]  grid-cols-1 relative">
        <div className="flex lg:justify-end justify-center">
          <div className="max-w-2xl p-6 sm:p-10 w-full">
            <PaymentSection />
          </div>
        </div>

        <div className="sticky top-0 left-0 ">
          <OrderSummary />
        </div>
      </div>
    </>
  );
};

export default CheckoutPage;
